import { render } from "./QuestionsQuizChallenge.vue?vue&type=template&id=65db5ee1&translate=no"
import script from "./QuestionsQuizChallenge.vue?vue&type=script&lang=js"
export * from "./QuestionsQuizChallenge.vue?vue&type=script&lang=js"

import "./QuestionsQuizChallenge.vue?vue&type=style&index=0&id=65db5ee1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__